import { useEffect } from 'react';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { useAppForm } from 'shared/UI/UIKit/Form';
import { useAppDispatch } from 'shared/services/redux/hooks/use-dispatch';
import { useAppSelector } from 'shared/services/redux/hooks/use-selector';
import { updateMunicipalityAction } from 'features/municipalities/redux/actions';
import type { EditMunicipalityModalProps, MunicipalityFormValues } from './types';
import { useRegions } from '../../Form/Municipality/use-regions';
import { MunicipalityModalFooter } from '../ModalFooter';
import { MunicipalityForm } from '../../Form/Municipality';

export const EditMunicipalityModal = (props: EditMunicipalityModalProps) => {
  const [form] = useAppForm<MunicipalityFormValues>();

  const dispatch = useAppDispatch();
  const { regions, loading: loading } = useRegions();

  const { selectedMunicipality } = useAppSelector((state) => state.municipalitiesState);

  useEffect(() => {
    if (props.visible && selectedMunicipality && regions.length > 0) {
      form.setFieldsValue({ ...selectedMunicipality });
    }
  }, [props.visible, selectedMunicipality, regions]);

  const hideModal = () => {
    form.resetFields();
    props.hide();
  };

  const onSubmit = () => {
    if (!selectedMunicipality) return;

    form.validateFields().then((values) => {
      dispatch(
        updateMunicipalityAction({
          ...selectedMunicipality,
          ...values,
          regionId: values.regionId,
        }),
      )
        .unwrap()
        .then(() => {
          hideModal();
        });
    });
  };

  const footer = (
    <MunicipalityModalFooter hideModal={hideModal} onSubmit={onSubmit} title="Сохранить" />
  );
  const content = <MunicipalityForm form={form} regionOptions={regions} regionsLoading={loading} />;

  return (
    <AppModal
      visible={props.visible}
      onCancel={hideModal}
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Редактировать муниципалитет"
      maskClosable={false}
    />
  );
};
